import { render, staticRenderFns } from "./person_step_2.vue?vue&type=template&id=56f41eb5&"
import script from "./person_step_2.vue?vue&type=script&lang=js&"
export * from "./person_step_2.vue?vue&type=script&lang=js&"
import style0 from "./person_step_2.vue?vue&type=style&index=0&id=56f41eb5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports